import {FeatureFlagEnum} from 'src/api/ProactApiClient';
import {createDomainSession} from 'src/offline/domainSession';
import type {EnsureDomainSessionOptions} from 'src/offline/domainSession';
import {store} from 'src/redux/store';
import {getOfflineBundle} from './api';
import {buildFormsHydrationPlan, estimateBundleBytes} from './formsBundle';
import {formDefinitionsListKey, FORMS_CONTEXT_KEY} from './snapshotKeys';

export type EnsureFormsOfflineSessionOptions = EnsureDomainSessionOptions;

/** Definitions cached longer than this are refreshed by the scheduler. */
export const FORMS_CACHE_MAX_AGE_MS = 6 * 60 * 60 * 1000;

const hasFormsFeature = (): boolean =>
  store
    .getState()
    .session.instance?.activeFeatures?.includes(FeatureFlagEnum.Forms) === true;

export const formsSession = createDomainSession({
  contextKey: FORMS_CONTEXT_KEY,
  isEnabled: hasFormsFeature,
  fetchBundle: getOfflineBundle,
  buildPlan: buildFormsHydrationPlan,
  estimateBytes: estimateBundleBytes,
  staleKey: formDefinitionsListKey,
  maxAgeMs: FORMS_CACHE_MAX_AGE_MS,
  storageAlertText:
    'Not enough storage to save forms for offline use. Free up space on this device to fill forms offline.',
  offlineAlertText: 'You are offline. Reconnect to refresh offline forms.',
});

export const ensureFormsOfflineSession = (
  options: EnsureFormsOfflineSessionOptions = {}
): Promise<void> => formsSession.ensure(options);

export const subscribeFormsCache = formsSession.subscribe;
export const isFormsCacheRefreshing = formsSession.isRefreshing;
export const isFormsCacheStale = formsSession.isStale;
